import PropTypes from 'prop-types';
import { googleApi, countryRestrictions, GO0GLE_API_KEY } from '../settings';
const axios = require('axios');

export const googleAutoCompleteApi = location => {
  return axios
    .get(`${googleApi}?input=${location}&key=${GO0GLE_API_KEY}&components=${countryRestrictions}`)
    .then(res => {
      return res;
    })
    .catch(error => {
      throw error;
    });
};

export const getDetailsByPlaceID = placeID => {
  return axios({
    url: `https://maps.googleapis.com/maps/api/place/details/json?key=${GO0GLE_API_KEY}&place_id=${placeID}`,
    method: 'GET'
  })
    .then(res => res)
    .catch(e => {
      throw e;
    });
};
